import { useState, useEffect } from 'react';

export default function ThemeToggle() {
  const [theme, setTheme] = useState('dark');

  useEffect(() => {
    const saved = localStorage.getItem('theme') || 'dark';
    setTheme(saved);
    applyTheme(saved);
  }, []);

  function applyTheme(t) {
    document.documentElement.setAttribute('data-theme', t);
    
    if (t === 'light') {
      document.documentElement.style.setProperty('--bg', '#f5f5f5');
      document.documentElement.style.setProperty('--bg2', '#ffffff');
      document.documentElement.style.setProperty('--text', '#1a1a2e');
      document.documentElement.style.setProperty('--text2', '#4a4a6a');
      document.documentElement.style.setProperty('--card-bg', 'rgba(0,0,0,0.05)');
    } else {
      document.documentElement.style.setProperty('--bg', '#0f0f1a');
      document.documentElement.style.setProperty('--bg2', '#1a1a2e');
      document.documentElement.style.setProperty('--text', '#ffffff');
      document.documentElement.style.setProperty('--text2', '#a0a0b0');
      document.documentElement.style.setProperty('--card-bg', 'rgba(255,255,255,0.05)');
    }
  }

  function toggle() {
    const newTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
    applyTheme(newTheme);
  }

  return (
    <button
      onClick={toggle}
      style={{
        background: 'rgba(255,255,255,0.1)',
        border: 'none',
        borderRadius: 8,
        padding: '8px 12px',
        cursor: 'pointer',
        fontSize: 18,
      }}
      title={theme === 'dark' ? 'Светлая тема' : 'Тёмная тема'}
    >
      {theme === 'dark' ? '☀️' : '🌙'}
    </button>
  );
}
